import "./style.moduleRenamed.css";

export const methodEditor = "style-module__methodEditor___p1lzZ";
export const header = "style-module__header___etVdw";
export const btns = "style-module__btns___rYP0Y";
export const content = "style-module__content___84jd9";
export const left = "style-module__left___HstTT";
export const info = "style-module__info___k-3FC";
export const codeArea = "style-module__codeArea___4Q6Nw";
export const toggleSetting = "style-module__toggleSetting___tdmHJ";
export const toggleBtn = "style-module__toggleBtn___jMdGQ";
export const leftContent = "style-module__leftContent___myD3O";
export const right = "style-module__right___saUXE";
export const methodInfo = "style-module__methodInfo___MiB00";
export const settings = "style-module__settings___r87HK";
export const full = "style-module__full___I2HsK";
export const contentBlock = "style-module__contentBlock___lglGx";
export const methodHeader = "style-module__methodHeader___j3UZm";
export const highlightForCode = "style-module__highlightForCode___NRIYk";

export default {
  methodEditor: "style-module__methodEditor___p1lzZ",
  header: "style-module__header___etVdw",
  btns: "style-module__btns___rYP0Y",
  content: "style-module__content___84jd9",
  left: "style-module__left___HstTT",
  info: "style-module__info___k-3FC",
  codeArea: "style-module__codeArea___4Q6Nw",
  toggleSetting: "style-module__toggleSetting___tdmHJ",
  toggleBtn: "style-module__toggleBtn___jMdGQ",
  leftContent: "style-module__leftContent___myD3O",
  right: "style-module__right___saUXE",
  methodInfo: "style-module__methodInfo___MiB00",
  settings: "style-module__settings___r87HK",
  full: "style-module__full___I2HsK",
  contentBlock: "style-module__contentBlock___lglGx",
  methodHeader: "style-module__methodHeader___j3UZm",
  highlightForCode: "style-module__highlightForCode___NRIYk",
};